import React, { createContext, useContext } from "react";
import axiosFactory, { METHOD_POST } from "../helpers/AxiosFactory";
import { CONTACT_FORM } from "../helpers/UrlConstants";

const ContactContext = createContext();
export function useContactContext() {
  return useContext(ContactContext);
}
export default function ContactProvider({ children }) {
  async function SendForm(data) {
    return await axiosFactory({
      url: CONTACT_FORM,
      method: METHOD_POST,
      data: data,
    });
  }
  const value = {
    SendForm,
  };
  return (
    <ContactContext.Provider value={value}>{children}</ContactContext.Provider>
  );
}
